import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import logo from "@/assets/logo.svg";

const navItems = [
  { label: "Our Snacks", id: "meet-the-states" },
  { label: "Our Philosophy", id: "brand-manifesto" },
];

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMobileOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 bg-background/95 backdrop-blur-md border-b border-border/40">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4 relative">
        {/* Left nav */}
        <nav className="hidden items-center gap-8 md:flex flex-1">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-[11px] font-bold uppercase tracking-[0.15em] text-foreground transition-colors hover:text-foreground/80"
            >
              {item.label}
            </button>
          ))}
        </nav>

        {/* Centered logo */}
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="absolute left-1/2 -translate-x-1/2"
        >
          <img src={logo} alt="State Snacks" className="h-10 md:h-12" />
        </button>

        {/* Right CTA */}
        <div className="hidden md:flex items-center justify-end flex-1">
          <Button
            variant="hero"
            size="sm"
            className="active:scale-[0.97] transition-all duration-200 text-[11px] uppercase tracking-[0.1em]"
            onClick={() => scrollTo("reserve")}
          >
            Join the Waitlist
          </Button>
        </div>

        <button
          className="text-foreground md:hidden"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {mobileOpen && (
        <div className="border-t border-border/50 bg-background px-6 py-5 md:hidden animate-fade-in">
          <div className="flex flex-col gap-5">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollTo(item.id)}
                className="text-left text-[11px] font-bold uppercase tracking-[0.15em] text-foreground/60 transition-colors hover:text-foreground"
              >
                {item.label}
              </button>
            ))}
            <Button variant="hero" size="sm" onClick={() => scrollTo("reserve")} className="text-[11px] uppercase tracking-[0.1em]">
              Join the Waitlist
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
